'use strict';
/**
 * @author Maxim Seredkin
 */
export default ['$resource',
    function ($resource) {
        return $resource('api/certificate/:id', null, {
            send: { url: 'api/certificate', method: 'POST' },
            remove: {method: 'DELETE'},
            certificates: { url: 'api/certificate/list', method: 'GET' },
            projects: { url: 'api/certificate/projects', method: 'GET' },
            count: { url: 'api/certificate/projects/count', method: 'GET' },
            sign: { url: 'api/certificate/projects/sign', method: 'POST' },
        });
    }];